import { useEffect, useState } from "react";

export const chartColors = {
  axis: "#6B6B6B",
  darkAxis: "#A6AECE",
  grid: "#D1DAE4",
  darkGrid: "#2E3564",
  blue: "#2563EB",
  ink: "#1B2559",
  green: "#008000",
  sky: "#00B4D8",
  surface: "#1A1F3F",
};

export const useChartTheme = () => {
  const [isDark, setIsDark] = useState(() =>
    typeof document !== "undefined" ? document.documentElement.classList.contains("dark") : false
  );

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return {
    axis: isDark ? chartColors.darkAxis : chartColors.axis,
    grid: isDark ? chartColors.darkGrid : chartColors.grid,
    tooltipBackground: isDark ? chartColors.surface : "#ffffff",
    tooltipText: isDark ? chartColors.darkAxis : "#323437",
  };
};
